import React from 'react';
import './App.css';
import Header from './components/Header.js'
import Home from './components/Home.js'

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Home></Home>     
    </div>
  );
}

export default App;
